import { Box, Button, IconButton, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import { UnstyledLink } from "Components/Routes/UnstyledLink";
import { appUrl } from "Utils/UrlUtils";
import { Resources, useResource } from "Translations/Resources";
import { useIsMobile } from "Hooks/useIsMobile";
import { useCurrentUserAccessRole } from "Hooks/useCurrentUserAccessRole";
import { canRoleFollow } from "Utils/Social/socialRules";

export const ChatTitleRow = () => {
  const { t } = useResource();
  const isMobile = useIsMobile();
  // Same split as the main menu: social personas have a People page, business personas
  // (Merchant, Hunter) a followers page with a people search — the link and its label follow
  // the persona.
  const isSocialPersona = canRoleFollow(useCurrentUserAccessRole());

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      px={2}
      py={1}
      flexShrink={0}
      borderBottom={isMobile ? undefined : "1px solid"}
      borderColor="divider"
    >
      <Box display="flex" alignItems="center" gap={1}>
        {/* 44px touch target around a 16px glyph; the negative margin gives the extra padding
            back so the arrow and the title stay where they were. */}
        <IconButton
          component={UnstyledLink}
          to={appUrl("dashboard")}
          aria-label={t(Resources.Common.Back)}
          sx={{ p: 1.75, mx: -1.125 }}
        >
          {/* Same chevron as PageTitle: the viewBox is cropped to the glyph so the arrow itself is
              16px tall instead of sitting small inside the icon's 24px frame. The colour goes on
              the SVG, not the button — the link's own styled colour (primary) would win otherwise. */}
          <ChevronLeftIcon
            viewBox="8 6 7.41 12"
            sx={{ width: 16, height: 16, color: "common.black" }}
          />
        </IconButton>
        <Typography variant="h5" fontWeight={700}>
          {t(Resources.Chat.Title)}
        </Typography>
      </Box>
      <Button
        component={UnstyledLink}
        to={appUrl(isSocialPersona ? "people" : "followers")}
        size="small"
        variant="text"
        startIcon={<PeopleAltOutlinedIcon />}
        sx={{ textTransform: "none" }}
      >
        {t(Resources.Chat.FindPeople)}
      </Button>
    </Box>
  );
};
